import type { AxiosRequestConfig } from "axios";
import request from "@/plugins/axios";
import type {
  ApiOrderDetailParams,
  ApiOrderDetailResponse,
  MyOrderApiParams,
  MyOrderApiResponse,
  PurchaseApiParams,
  UpdateApiParams,
  UpdateApiResponse,
  SalesOrderApiParams,
  SalesOrderApiResponse,
  MyDataApiParams,
  MyDataApiResponse,
  SaveApiInfoParams,
  ApiDetailParams,
  ApiDetailResponse,
  DebugApiParams,
} from "./types";
const isDev =
  process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test";
const url = (process.env.VUE_APP_API_URL || "") + (isDev ? "/api" : "");
/**
 * 保存API信息
 */
export function saveApiInfo(params: SaveApiInfoParams) {
  const config: AxiosRequestConfig = {
    url: `${url}/api/save`,
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return request<number>(config);
}

/**
 * 获取API详情
 */
export function getApiDetail(params: ApiDetailParams) {
  const config: AxiosRequestConfig = {
    url: `${url}/api/detail`,
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return request<ApiDetailResponse>(config);
}
/**
 * 删除api数据
 */
export function deleteApi(apiId: number) {
  const config: AxiosRequestConfig = {
    url: `${url}/api/delete`,
    method: "post",
    data: { apiId },
    headers: {
      "Content-Type": "application/json",
    },
  };
  return request<number>(config);
}
/**
 * 修改时获取API详情
 */
export function getApiDetailToUpdate(params: ApiDetailParams) {
  const config: AxiosRequestConfig = {
    url: `${url}/api/detailToUpdate`,
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return request<ApiDetailResponse>(config);
}
/**
 * 调试API接口
 */
export function debugApi(params: DebugApiParams) {
  const config: AxiosRequestConfig = {
    url: `${url}/api/debug`,
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return request<string>(config);
}
/**
 * 我的api订单详情
 */
export function getApiOrderDetail(params: ApiOrderDetailParams) {
  const config: AxiosRequestConfig = {
    url: `${url}/order/detail`,
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return request<ApiOrderDetailResponse>(config);
}

/**
 * 我的订单-api
 */
export function getMyOrderList(params: MyOrderApiParams) {
  const config: AxiosRequestConfig = {
    url: `${url}/order/list`,
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return request<MyOrderApiResponse>(config);
}

/**
 * 购买api
 */
export function purchaseApi(params: PurchaseApiParams) {
  const config: AxiosRequestConfig = {
    url: `${url}/order/purchase`,
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return request<string>(config);
}

/**
 * 修改api数据
 */
export function updateApi(params: UpdateApiParams) {
  const config: AxiosRequestConfig = {
    url: `${url}/api/update`,
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return request<UpdateApiResponse>(config);
}

/**
 * 销售订单-api
 */
export function getSalesOrderList(params: SalesOrderApiParams) {
  const config: AxiosRequestConfig = {
    url: `${url}/api/getApiOrderList`,
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return request<SalesOrderApiResponse>(config);
}

/**
 * 我的数据-api
 */
export function getMyData(params: MyDataApiParams) {
  const config: AxiosRequestConfig = {
    url: `${url}/api/getMyData`,
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return request<MyDataApiResponse>(config);
}

/**
 * 我的数据-api
 */
export function getMyApi(params: MyDataApiParams) {
  const config: AxiosRequestConfig = {
    url: `${url}/api/getBuyerApi`,
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return request<MyDataApiResponse>(config);
}

// api支付请求
export function getPayParameter(code: string) {
  const config: AxiosRequestConfig = {
    url: `${url}/order/queryOrderCache`,
    method: "post",
    data: {
      orderCode: code,
    },
  };
  return request(config);
}

export function getPayParameterNew(code: string, taskCode: string) {
  const config: AxiosRequestConfig = {
    url: `${url}/order/create/payOrder`,
    method: "post",
    data: {
      code,
      taskCode,
    },
  };
  return request(config);
}
